import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  CommonMediaQueries,
  IconModule,
  MediaScreenService,
} from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { Currency } from '@iw/core/entities';

import { ORDER_STATUSES } from './order-status.constants';

@Component({
  selector: 'iw-order-status',
  imports: [IconModule, TranslateModule, NgTemplateOutlet],
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusComponent {
  readonly #mediaScreenService = inject(MediaScreenService);
  readonly currency = input<Currency>();
  readonly status = input.required<string>();

  readonly currentStatus = computed(
    () => ORDER_STATUSES.get(this.status()) ?? 'created',
  );

  isDesktop = toSignal(
    this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  );

  readonly steps = computed(() => {
    const status = this.currentStatus();
    const overrides: Record<string, string> = {
      cancelled: 'cancelled',
      rejected: 'rejected',
    };

    const last = overrides[status] ?? 'completed';
    return ['created', 'in-progress', last];
  });
}
